import api from 'data/client';
import { SupportData } from 'data/types/support';
import { normalizeSupport } from 'model/support';

const getSupport = async () => {
  const response = await api.get<SupportData>('/support');
  return normalizeSupport(response.data);
};

export default getSupport;
